import { useEffect, useState } from 'react';
import { bridge, isNotNil } from 'shared/src/utils';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { AdAction } from 'shared/src/utils/eventLogger/adLogger/types';

export const useLogDisplayRelatedGoods = (params: {
  isSuccess: boolean;
  isLoading: boolean;
  focused: boolean;
  targetList: {
    ad: object | null;
    logging: { analytics: object; ably_only_log: object };
  }[];
}) => {
  const goodsSno = useGoodsSno();

  const [logged, setLogged] = useState(false);
  useEffect(() => {
    if (
      params.focused &&
      params.isSuccess &&
      params.targetList.length > 0 &&
      !logged
    ) {
      setLogged(true);

      bridge.logAnalyticsEvent({
        name: 'VIEW_DISPLAY_RELATED_GOODS',
        analytics: {
          GOODS_SNO: goodsSno,
        },
      });

      params.targetList.forEach(item => {
        bridge.logAnalyticsEvent({
          name: 'DISPLAY_GOODS',
          channel: ['firebase', 'amplitude', 'ablylog', 'facebook'],
          analytics: {
            SCREEN: 'GOODS_DETAIL',
            LIST_ID: 'goods_list_similar_thumbnail',
            ...item.logging.analytics,
          },
          ably_only_log: { ...item.logging.ably_only_log },
        });
        if (isNotNil(item.ad)) {
          bridge.logAdEvent({ action: AdAction.DISPLAY, ad: item.ad });
        }
      });
    }
  }, [params, logged, goodsSno]);
};
